import DatalabelsPlugin from 'chartjs-plugin-datalabels';
export const Datalabels = DatalabelsPlugin;
export {} from 'chartjs-plugin-datalabels';
